import Vue from 'vue'
import { setup } from 'axios-cache-adapter'
import store from '@/store'
import * as Types from './store/types'

const instance = setup({
    // baseURL: 'http://127.0.0.1:8005/v1',
    // baseURL: 'http://187.4.202.237:3005/v1/',
    baseURL: 'https://habibshpostos.com.br:3002/v1',
    headers: {
        'Content-Type': 'application/json'
    },
    cache: {
        readOnError: (error, request) => {
            if (error && error.response && error.response.status) {
                return (
                    error.response.status >= 400 && error.response.status < 600
                )
            }

            return true
        },
        clearOnStale: false,

        invalidate: async (config, request) => {
            if (request.clearCacheEntry) {
                await config.store.removeItem(config.uuid)
            }
        }
    }
})

instance.interceptors.request.use(
    function(config) {
        store.commit(Types.APP_LOADING)

        const token = store.getters.token

        config.headers.Authorization = `Bearer ${token || ''}`

        return config
    },
    function(error) {
        // Do something with request error

        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    function(response) {
        store.commit(Types.APP_LOADING)

        return response
    },
    function(error) {
        if (error && error.response && error.response.status === 401) {
            if (window.location.href.includes('login')) {
                Vue.toasted.global.error({
                    message: 'Usuário ou senha inválida'
                })
            } else {
                Vue.toasted.global.error({
                    message: 'Operação não autorizada'
                })
            }
        } else {
            if (error.message.includes('') && !navigator.onLine) {
                Vue.toasted.global.error({
                    message: 'Verifique sua conexão com a internet'
                })
            } else {
                Vue.toasted.global.error({
                    message: 'Não foi possivel realizar a ação'
                })
            }
        }

        console.warn(error)

        store.commit(Types.APP_LOADING)
    }
)

export default instance
